export const INDENT_UNIT = 30;

export const TREE_ACTIONS = {
  collapseNode: 'collapseNode',
  collapseAllNodes: 'collapseAllNodes',
  expandNode: 'expandNode',
  highlightNode: 'highlightNode',
  moveDown: 'moveDown',
  moveUp: 'moveUp',
  filterNodes: 'filterNodes',
  regenerateTree: 'regenerateTree',
  moveNode: 'moveNode',
  addChildNodes: 'addChildNodes',
  collapseNodeRecursive: 'collapseNodeRecursive',
  expandNodeRecursive: 'expandNodeRecursive',
} as const;
